import React, { useRef, useEffect, useState,useContext } from 'react';

import './Home.css';

import logo from '../../img/logo.png';
import { Row, Col, Dropdown} from 'antd';
import type { MenuProps } from 'antd'
import ImageCarousel from '../../components/ImageCarousel/ImageCarousel';
import s0 from '../../img/s0.jpg';
import s1 from '../../img/s1.jpg';
import s2 from '../../img/s2.jpg';
import s3 from '../../img/s3.jpg';
import path1 from '../../img/path1.png';
import couple from '../../img/couple.png';
import mouse_scroll from '../../img/mouse_scroll.png';
import { CaretUpOutlined, MenuOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import Menu1 from '../MainMenu/Menu';
import DataCarousel from '../../components/DataCarousel/DataCarousel';
import LanguageContext from "../../store/language-context";
import { useTranslation } from "react-i18next";
import { Menu } from 'antd';
import { CustomNavLinkSmallLanguage } from "./styles"
import i18next from 'i18next';
import CardCarousel from 'components/CardCarousel/CardCarousel';
import { Link } from 'react-router-dom';

const images = [s0, s1, s2, s3];
const sectionWidth = window.innerWidth - 250;
const scrollMultiplier = 0.005;

const Home = () => {
  const controller = new AbortController();
  const { signal } = controller;
  const { t, i18n } = useTranslation()

  var currentLanguageCode = i18next.resolvedLanguage;
  const languageCtx = useContext(LanguageContext);

  const containerRef = useRef<HTMLDivElement>(null);
  const [currentSection, setCurrentSection] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [pois, setPois] = useState([]);

  const [open, setOpen] = useState(false);

  const handleClick : MenuProps['onClick'] = ({ key }: any) => {
    i18n.changeLanguage(key);
    languageCtx.languageCodeHandler();
  };

  const menu = (
    <Menu className="menu"
      onClick={handleClick}
      items={[
        {
          key: 'el',
          label: 'ΕΛ',
        },
        {
          key: 'en',
          label: 'EN'
        },
        {
          key: 'fr',
          label: 'FR',
        },
        {
          key: 'de',
          label: 'DE',
        },
      ]}
    />
  )

  useEffect(() => {
    getCategoryPois()
      .then((res1) => {
        console.log(res1);

        setPois(res1.success)
      })

      .catch((e) => {
        console.log(e.message)
      })
  }, [])

  const getCategoryPois = async () => {
    const url = `https://dimosapokoronou.mitos.cityguideplatform.com/api/pois?category_id=1&lang=${currentLanguageCode}`
    const response = await fetch(url,
      {
        signal,
        headers: {
          'X-API-KEY': 'OHiqSkWShHTbMGLoB5Am',
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
    if (!response.ok) {
      throw new Error('Data could not be fetched!')
    }
    else {

      return response.json()
    }
  };

  const handleScroll = () => {
    if (containerRef.current) {
      const scrollPosition = containerRef.current.scrollLeft;
      const newSection = Math.round(scrollPosition / sectionWidth);
      setCurrentSection(newSection);
    }
  };

  const scrollToSection = (section: number) => {
    const targetScroll = section === 2 ? section * sectionWidth + 800 : section * sectionWidth;
    containerRef.current!.scrollTo({ left: targetScroll, behavior: 'smooth' });
    setCurrentSection(section);
  };

  useEffect(() => {
    handleScroll();
  }, []);

  return (
    <div
      className={`${sectionWidth > 1250 ? `horizontal-scroll-container` : null} ${isMenuOpen ? 'menu-open' : ''}`}
      ref={containerRef}
      onWheel={(e) => {
        const delta = e.deltaY * scrollMultiplier;
        if (delta > 0 && currentSection < 2) {
          scrollToSection(currentSection + 1);
        } else if (delta < 0 && currentSection > 0) {
          scrollToSection(currentSection - 1);
        }
        e.preventDefault();
      }}
    >
      {/* side menu */}
      <Menu1 open={open} setOpen={setOpen} />

      {/* menu button */}
      <div
        className="burger-icon"
        onClick={() => setOpen(true)}
        style={{ top: 20, zIndex: 1, cursor: 'pointer' }}
      >
        <MenuOutlined className='menu-burger' />
      </div>

      {/* main page container */}
      <div className="horizontal-scroll-section section1" style={{ width: sectionWidth }}>
        {/* header logo */}
        <div className="logo-container">
          <img src={logo} className="logo" alt="logo" />
        </div>

        {/* section 1 */}
        <div className="section1-container">
          <Row gutter={16}>
            {/* section description */}
            <Col className="gutter-row" span={5}>
              <div>
                <h2 className="section1Title">{t('Ανακαλυψε τα Μουσεια του Δημου Αποκορωνου')}</h2>
                <p className="section1Description">{t('Καλώς ήρθατε στη διαδικτυακή πύλη που σας προσκαλεί να ανακαλύψετε την πλούσια πολιτιστική κληρονομιά του Δήμου Αποκορώνου. Εξερευνήστε τα εκθέματα των τοπικών μουσείων και γνωρίστε μέσα από αυτά την ιστορία και τις παραδόσεις της περιοχής μας.')}</p>
              </div>
              
              <button className="museumsButton"><Link to="/museums">{t("Μουσεία")}</Link></button>
            </Col>

            {/* carousel */}
            <Col className="gutter-row" span={5} offset={8}>
              <ImageCarousel images={images} />
            </Col>
          </Row>
        </div>
        
        {/* couple overlay */}
        <img className="coupleOverlay" src={couple} alt="couple"/>
      </div>
     
      {/* section 2 */}
      <div className="horizontal-scroll-section section2" style={{ width: sectionWidth, position: 'relative' }}>
        <div className="overlaySection" style={{ position: 'relative' }}>
          {/* bottom left bubble designs */}
          <span className="bubble1"></span>
          <span className="bubble2"></span>
          <span className="bubble3"></span>

          {/* main description */}
          <DataCarousel/>

          {/* top right bubble designs */}
          <span className="bubble4"></span>
          <span className="bubble5"></span>
          <span className="bubble6"></span>
        </div>
      </div>

      {/* in between sections image */}
      <img className="pathImage" src={path1}/>

      {/* section 3 */}
      <div className="horizontal-scroll-section section3" style={{ width: sectionWidth }}>
        <h2 className="museumsTitle">{t('Μουσεία')}</h2>
        <CardCarousel museums={pois} />
      </div>

      {/* footer section */}
      <div className="footerHome">
        <CustomNavLinkSmallLanguage>
          <div className="footerIconsContainer">
            {/* footer icons */}
            <SearchOutlined className="footerIcon"/>
            <UserOutlined className="footerIcon"/>

            {/* language selector */}
            <Dropdown overlay={menu} >
                <span className="languageButton"> 
                  {currentLanguageCode === 'el' && 'ΕΛ'} {currentLanguageCode === 'en' && 'ΕΝ'} {currentLanguageCode === 'fr' && 'FR'} {currentLanguageCode === 'de' && 'DE'}
                  <CaretUpOutlined style={{width: '.75rem', marginLeft: '-0.15rem'}}/>
                </span>
            </Dropdown>
          </div>
        </CustomNavLinkSmallLanguage>  

        {/* scroll indicator */}
        <div className="mouseContainer" onClick={(e) => { 
            if(currentSection < 2) scrollToSection(currentSection + 1); 
            if(currentSection === 2) scrollToSection(0); 
            e.preventDefault();
          }}
        >
          <span className="scroll_text">{t("Κάντε κύλιση για πλοήγηση")}</span> 
          <img src={mouse_scroll} alt="Mouse icon" />
        </div>
      </div>
    </div>
  );
};

export default Home;